import {getField, updateField} from 'vuex-map-fields';
import {AppWebSocketCompress} from '@/commonFunction/appWebSocketCompress'
import commonFunction from '@/commonFunction/commonFunction'
import pako from 'pako'
import Vue, {reactive} from 'vue';

export default class {
    constructor(wsUrl) {
        this.state = {
            wsUrl: wsUrl,
            webConnect: null,
            itemList: [],
            tableProperty: {},
            pageProperty: {},
            itemListCommon: {},
            aggregateItemList: {},
            searchTerm: null,
            searchTermFile: null,
            filters: [],
            group_filters: null,
            filtersListConst: [],
            selectedItemList: [],
            editedItem: {},
            rawEditedItem: {},
            rawUidEditedItem: {},
            savedEditedItem: {},
            validateEditedItem: {},
            backupEditedStack: [],
            backupCommonStack: [],
            editedItemCommon: {},
            itemUid: null,
            dialogItem: false,
            options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['title'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: false,

            },
            totalRecords: 0,
            loading: false,
            commandLoading: false,

            snack_color: 'info',
            snack_text: '',
            snack_flag: false,

            confirm_request: {
                dialog: false,
                message: null,
                request: {},
                type: null,
                timeout: -1,
                result: false,
            }
            ,
            saveCallback: null,
            historyActive: false,
        }
        this.actions = {
            async openWebSocket(ctx) {
                if (ctx.state.webConnect == null) {
                    console.log('openWebSocket to ' + ctx.state.wsUrl)
                    ctx.state.webConnect = new AppWebSocketCompress(ctx.state.wsUrl, ctx, 'fetchMessage', 5000)
                    ctx.state.webConnect.connectSocket()
                }
                while (ctx.state.webConnect.connection.readyState !== WebSocket.OPEN) {
                    // console.log('Wait while not connected to', ctx.state.webConnect.connection.url)
                    await delay(100)
                }
            },
            async fetchMessage(ctx, data) {
                // console.log('fetchMessage ', ctx.state.wsUrl, data)
                ctx.commit('updateMessage', data)
            },

            async fetchRequest(ctx) {
                console.log('fetchRequest', ctx.state.wsUrl, ctx.state.confirm_request.request)
                // ctx.commit('updateCommandLoading', true)
                ctx.state.webConnect.connection.send(JSON.stringify(ctx.state.confirm_request.request))
            },

            async fetchDetailRestore(ctx) {
                ctx.commit('restoreEditedItem')
            },

            async fetchValidateItem(ctx, dto_validate_model) {
                if (dto_validate_model === null)
                    return
                console.log('fetchValidateItem', ctx.state.wsUrl, ctx.state.editedItem, dto_validate_model)
                ctx.commit('updateItemUid', ctx.state.editedItem.uid)
                await ctx.dispatch('openWebSocket')
                const request = {
                    dto_model: dto_validate_model,
                    dto: {
                        item: ctx.state.editedItem,
                    },
                }
                ctx.state.webConnect.connection.send(compressed(JSON.stringify(request)))
                // ctx.state.webConnect.connection.send(JSON.stringify(request))
            },

            async fetchItem(ctx, {itemUid, dto_detail_model, parentUid, metadata = null, callback = null}) {
                console.log('fetchItem', ctx.state.wsUrl, itemUid)
                ctx.commit('updateLoading', true)
                ctx.commit('updateItemUid', itemUid)
                await ctx.dispatch('openWebSocket')
                let request = {
                    dto_model: dto_detail_model,
                    dto: {
                        uid: itemUid,
                        parent_uid: parentUid,
                        metadata: metadata,
                    },
                }
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                console.log('fetchItem', ctx.state.wsUrl, request, dto_detail_model)
                if (callback != null)
                    callback()
            },

            async fetchRemoveItem(ctx, {itemUid, dto_remove_model}) {
                console.log('fetchItem', ctx.state.wsUrl, itemUid)
                ctx.commit('updateLoading', true)
                ctx.commit('updateItemUid', itemUid)
                await ctx.dispatch('openWebSocket')
                let request = {
                    dto_model: dto_remove_model,
                    dto: {
                        uid: itemUid,
                    },
                }
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                console.log('fetchRemoveItem', ctx.state.wsUrl, request, dto_remove_model)
            },

            async fetchSaveEditedItem(ctx, dto_save_model) {
                console.log('fetchSaveEditedItem', ctx.state.wsUrl, ctx.state.editedItem, ctx.state.parentItemUid, dto_save_model)
                ctx.commit('updateLoading', true)
                ctx.commit('updateCommandLoading', true)
                await ctx.dispatch('openWebSocket')
                const request = {
                    dto_model: dto_save_model,
                    dto: {
                        item: ctx.state.editedItem,
                    },
                }
                ctx.state.webConnect.connection.send(compressed(JSON.stringify(request)))
            },

            async fetchSaveCloseEditedItem(ctx, {dto_save_model, callback = null}) {
                console.log('fetchSaveEditedItem', ctx.state.wsUrl, ctx.state.editedItem, ctx.state.parentItemUid,
                    dto_save_model, callback)
                ctx.commit('updateLoading', true)
                ctx.commit('updateCommandLoading', true)
                ctx.commit('updateSaveCallback', callback)
                await ctx.dispatch('openWebSocket')
                const request = {
                    dto_model: dto_save_model,
                    dto: {
                        item: ctx.state.editedItem,
                    },
                }
                ctx.state.webConnect.connection.send(compressed(JSON.stringify(request)))
            },

            async fetchSaveItem(ctx, {item, dto_save_model}) {
                console.log('fetchSaveItem', ctx.state.wsUrl, item, dto_save_model)
                ctx.commit('updateCommandLoading', true)
                await ctx.dispatch('openWebSocket')
                const request = {
                    dto_model: dto_save_model,
                    dto: {
                        item: item,
                    },
                }
                ctx.state.webConnect.connection.send(compressed(JSON.stringify(request)))
            },

            async fetchSaveItemList(ctx, {itemList, dto_save_list_model}) {
                console.log('fetchSaveItemList', ctx.state.wsUrl, itemList, dto_save_list_model)
                // ctx.commit('updateCommandLoading', true)
                await ctx.dispatch('openWebSocket')
                const request = {
                    dto_model: dto_save_list_model,
                    dto: {
                        item_list: itemList,
                    },
                }
                ctx.state.webConnect.connection.send(compressed(JSON.stringify(request)))
            },

            async fetchItemList(ctx, dto_model = null) {
                ctx.commit('updateLoading', true)
                await ctx.dispatch('openWebSocket')
                let filters = structuredClone(ctx.state.filtersListConst)
                filters = [
                    ...ctx.state.filtersListConst,
                    ...ctx.state.filters,
                ]
                // console.log('fetchItemList filters', filters, ctx.state.filtersListConst, ctx.state.filters)
                let request = {
                    dto_model: dto_model,
                    dto: {
                        filters: filters,
                        group_filters: ctx.state.group_filters,
                        search_term: ctx.state.searchTerm,
                        orders: ctx.state.options.sortBy,
                        desc: ctx.state.options.sortDesc,
                        page: ctx.state.options.page,
                        page_size: ctx.state.options.itemsPerPage,
                    },
                }
                ctx.state.webConnect.connection.send(JSON.stringify(request))
                console.log('fetchItemList', ctx.state.wsUrl, ctx.state.filters, request, ctx.state.parentItemUid, dto_model)
            },

            async fetchConfirmResponse(ctx, confirm, dto_model = null) {
                console.log('fetchConfirmResponse', confirm, dto_model)
                ctx.commit('updateActionLoading', true)
                let request = {
                    command: 'confirm_response',
                    confirm: confirm,
                }
                await ctx.dispatch('openWebSocket')
                request['dto_model'] = dto_model
                ctx.state.webConnect.connection.send(JSON.stringify(request))
            },

            async fetchAction(ctx, {dto, dto_action_model}) {
                console.log('fetchActionItem', dto_action_model, dto)
                ctx.commit('updateCommandLoading', true)
                let request = {
                    dto_model: dto_action_model,
                    dto: dto,
                }
                await ctx.dispatch('openWebSocket')
                ctx.state.webConnect.connection.send(compressed(JSON.stringify(request)))
            },
            fetchRestoreEditedItem(ctx) {
                // console.log('fetchRestoreEditedItem')
                ctx.commit('updateRestoreEditedItem')
            },
        }

        this.mutations = {
            updateField,
            updateMessage(state, data) {
                console.log('updateMessage', state.wsUrl, data)
                if (data.command === 'list') {
                    state.totalRecords = data.total_records
                    state.itemList = structuredClone(data.items)
                    state.itemListCommon = structuredClone(data.common)
                    state.tableProperty = structuredClone(data.property)
                    state.loading = false
                    state.commandLoading = false
                    // console.log('after updateMessage list', state.wsUrl, state.itemList)
                }
                if (data.command === 'update_list') {
                    console.log('update_list', state.wsUrl)
                    state.itemListCommon = structuredClone(data.common)
                    let items = structuredClone(data.items)
                    for (let item of items) {
                        let updated = commonFunction.updateDeepDictionary(state.itemList, item)
                        // console.log('update_list updated', updated, state.itemList.length, state.itemList)
                        if (updated === false) {
                            if (data.append === 'first') {
                                state.itemList.unshift(item)
                                state.totalRecords += 1
                            }
                            if (data.append === 'last') {
                                state.itemList.push(item)
                                state.totalRecords += 1
                            }
                        }
                    }
                    state.tableProperty = structuredClone(data.property)
                    // console.log('update_list', state.wsUrl, state.itemList, items)
                }
                if (data.command === 'confirm_request') {
                    console.log('confirm_request', data, state.saveCallback)
                    state.confirm_request.dialog = data.dialog
                    state.confirm_request.message = data.message
                    state.confirm_request.request = data.request
                    state.confirm_request.type = data.type
                    state.confirm_request.timeout = data.timeout
                    state.confirm_request.color = data.color
                    state.loading = false
                    state.commandLoading = false
                    if (data.type === 'info' && !!state.saveCallback) {
                        console.log('confirm_request callback', state.saveCallback)
                        state.saveCallback()
                    }
                    state.saveCallback = null
                }
                if (data.command === 'update') {
                    let rowList = []
                    let existFlag = false
                    for (let item of state.itemList) {
                        if (item.uid === data.uid) {
                            rowList.push({...item, ...data.item})
                            existFlag = true
                        } else
                            rowList.push(item)
                    }
                    state.itemListCommon = {...state.itemListCommon, ...data.common}
                    state.itemList = structuredClone(rowList)
                    if (existFlag === false) {
                        if (state.options.page === 1)
                            state.itemList.unshift(data.item)
                        state.totalRecords += 1
                    }
                    state.loading = false
                    state.commandLoading = false
                    console.log('End updateMessage, command: update', state.itemList)
                }
                if (data.command === 'remove') {
                    let rowList = []
                    let existFlag = false
                    for (let item of state.itemList) {
                        if (item.uid !== data.uid) {
                            existFlag = true
                        } else
                            rowList.push(item)
                    }
                    state.itemList = structuredClone(rowList)
                    state.itemListCommon = {...state.itemListCommon, ...data.common}
                    if (existFlag === false) {
                        state.totalRecords -= 1
                    }
                    state.loading = false
                    state.commandLoading = false
                }
                if (data.command === 'detail') {
                    // console.log("data.command === 'detail'", state.itemUid, data.uid)
                    if (state.itemUid === data.uid) {
                        state.editedItem = structuredClone(data.item)
                        state.validateEditedItem = structuredClone(state.editedItem)
                        state.savedEditedItem = structuredClone(data.item)
                        state.editedItemCommon = structuredClone(data.common)
                        state.backupEditedStack = []
                        state.pageProperty = structuredClone(data.property)
                        state.loading = false
                        state.commandLoading = false
                        if (!!state.saveCallback)
                            state.saveCallback()
                        state.saveCallback = null
                        console.log('data.command === detail match', state.itemUid, data.item, data.common)
                    } else {
                        console.log('data.command === detail not match', state.itemUid, data.item, data.common)
                    }
                }
                if (data.command === 'detail_raw') {
                    console.log("data.command === 'detail_raw'", state.itemUid, data.uid)
                    if (state.itemUid === data.uid) {
                        state.rawEditedItem = structuredClone(data.item)
                        state.rawUidEditedItem = structuredClone(data.uid_dto)
                        state.editedItem = commonFunction.createProxy(state.rawEditedItem, state.rawUidEditedItem)
                        state.validateEditedItem = structuredClone(state.editedItem)
                        state.savedEditedItem = structuredClone(data.item)
                        state.editedItemCommon = structuredClone(data.common)
                        state.backupEditedStack = []
                        state.pageProperty = structuredClone(data.property)
                        state.loading = false
                        state.commandLoading = false
                        console.log('editedItem', data.item, data.common, state.rawEditedItem, structuredClone(state.editedItem), state.rawUidEditedItem)
                    } else {
                        console.log('editedItem not match', state.itemUid, data.item, data.common)
                    }
                }

                if (data.command === 'update_item') {
                    // console.log("data.command === 'update_item'", data)
                    let updated_item = structuredClone(data.item)
                    commonFunction.updateDeepDictionary(state.editedItem, updated_item)
                    state.validateEditedItem = structuredClone(state.editedItem)
                    if (data.set_data_changed === false)
                        state.savedEditedItem = structuredClone(state.editedItem)
                    // console.log('updateDeepDictionary after', state.editedItem, updated_item)
                }

                if (data.command === 'download') {
                    console.log("data.command === 'download'", data)
                    let blob_data = null
                    if (data.file_type === 'application/ms-excel')
                        blob_data = s2ab(atob(data.file_data))
                    else
                        blob_data = data.file_data
                    let blob = new Blob([blob_data], {type: data.file_type})
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = data.file_name;
                    link.click();
                }

                if (data.command === 'validate') {
                    if (state.itemUid === data.uid) {
                        if (state.backupEditedStack.length === 0 || (
                            JSON.stringify(state.validateEditedItem) !==
                            JSON.stringify(state.backupEditedStack[state.backupEditedStack.length - 1]))) {
                            // console.log('push to backupEditedStack', state.validateEditedItem)
                            state.backupEditedStack.push(structuredClone(state.validateEditedItem))
                        }
                        state.editedItem = structuredClone(data.item)
                        state.validateEditedItem = structuredClone(data.item)
                        state.pageProperty = structuredClone(data.property)
                        state.loading = false
                        // console.log('updateValidate', state.itemUid, data.item,)
                    } else {
                        // console.log('updateValidate not match', state.itemUid, data.item,)
                    }
                }
            }
            ,
            updateSelectedItemList(state, selectedItemList) {
                state.selectedItemList = selectedItemList
            }
            ,
            updateLoading(state, loading) {
                state.loading = loading
            }
            ,
            updateCommandLoading(state, loading) {
                state.commandLoading = loading
            },
            updateItemUid(state, itemUid) {
                // console.log('updateItemUid', itemUid)
                state.itemUid = itemUid
            },
            updateSaveCallback(state, callback) {
                // console.log('updateItemUid', itemUid)
                state.saveCallback = callback
            },
            updateRestoreEditedItem(state) {
                if (state.backupEditedStack.length > 0) {
                    state.validateEditedItem = structuredClone(state.backupEditedStack.pop())
                    state.editedItem = structuredClone(state.validateEditedItem)
                    // console.log('updateRestoreEditedItem', state.validateEditedItem)
                }
            },
        }

        this.getters = {
            getField,
            countBackup(state) {
                return state.backupEditedStack.length
            },
            isDataChange(state) {
                // console.log('isDataChange')
                // console.time('stringify')
                let editedItemString = JSON.stringify(state.editedItem)
                let savedEditedItemString = JSON.stringify(state.savedEditedItem)
                let compare = editedItemString !== savedEditedItemString
                // console.timeEnd('stringify')
                return compare
            },
        }
    }
}


function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

function compressed(data) {
    return pako.deflate(data)
}
